import {Icon, IconRegistry, Integer} from 'platform/foundation-tw';

import {MiraIconKey, miraIcons} from '../../icons/miraIcons';

const iconRegistry: IconRegistry = new Proxy({} as IconRegistry, {
  get(_target, prop: string) {
    const entry = miraIcons[prop as MiraIconKey];
    return entry?.Component;
  },
  has(_target, prop: string) {
    return prop in miraIcons;
  },
  ownKeys() {
    return Object.keys(miraIcons);
  },
  getOwnPropertyDescriptor() {
    return {enumerable: true, configurable: true};
  },
});

interface MiraIconProps {
  name: MiraIconKey;
  size?: Integer;
}

export function MiraIcon(props: MiraIconProps) {
  return <Icon value={props.name} iconRegistry={iconRegistry} size={props.size} />;
}
